import { render, staticRenderFns } from "./ProjectAuditLogsView.vue?vue&type=template&id=376bb09b&scoped=true&lang=html&"
import script from "./ProjectAuditLogsView.vue?vue&type=script&lang=ts&"
export * from "./ProjectAuditLogsView.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectAuditLogsView.vue?vue&type=style&index=0&id=376bb09b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376bb09b",
  null
  
)

export default component.exports